import { useEffect, useState } from 'react';
export function useDebounce(value, delay, debounceAfterLength) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const clearEvent = (timer) => {
        if (timer)
            clearTimeout(timer);
    };
    useEffect(() => {
        let timer = null;
        if (debounceAfterLength && String(value).length < debounceAfterLength)
            return () => clearEvent(timer);
        timer = setTimeout(() => setDebouncedValue(value), delay || 500);
        return () => clearEvent(timer);
    }, [value, delay, debounceAfterLength]);
    return debouncedValue;
}
//# sourceMappingURL=index.js.map